// Global screen recording manager
class ScreenRecordingManager {
  constructor() {
    this.screenStreamRef = null;
    this.screenRecorderRef = null;
    this.screenChunksRef = [];
    this.micStreamRef = null;
    this.isScreenRecording = false;
    this.screenSharingActive = false;
    this.screenShareError = "";
    this.testStarted = false;
  }

  // Set screen recording state
  setScreenRecordingState({
    screenStreamRef,
    screenRecorderRef,
    screenChunksRef,
    micStreamRef,
    isScreenRecording,
    screenSharingActive,
    screenShareError,
    testStarted
  }) {
    this.screenStreamRef = screenStreamRef;
    this.screenRecorderRef = screenRecorderRef;
    this.screenChunksRef = screenChunksRef || [];
    this.micStreamRef = micStreamRef;
    this.isScreenRecording = isScreenRecording;
    this.screenSharingActive = screenSharingActive;
    this.screenShareError = screenShareError || "";
    this.testStarted = testStarted;
  }

  // Get screen recording state
  getScreenRecordingState() {
    return {
      screenStreamRef: this.screenStreamRef,
      screenRecorderRef: this.screenRecorderRef,
      screenChunksRef: this.screenChunksRef,
      micStreamRef: this.micStreamRef,
      isScreenRecording: this.isScreenRecording,
      screenSharingActive: this.screenSharingActive,
      screenShareError: this.screenShareError,
      testStarted: this.testStarted
    };
  }

  // Clear screen recording state
  clearScreenRecordingState() {
    this.screenStreamRef = null;
    this.screenRecorderRef = null;
    this.screenChunksRef = [];
    this.micStreamRef = null;
    this.isScreenRecording = false;
    this.screenSharingActive = false;
    this.screenShareError = "";
    this.testStarted = false;
  }
}

// Create singleton instance
const screenRecordingManager = new ScreenRecordingManager();

export default screenRecordingManager;
